// 集中管理全局常量，避免各组件重复 hardcode
export const API = "/api";
export const GOOGLE_CLIENT_ID = "213851968461-nm8dc9ut7no26lpkb7f3ha4pkmu2ketj.apps.googleusercontent.com";
